import { Account } from '../common/types/Accounts';
import React from 'react';

export function useHasAccountChanged(account?: Account): boolean {
  const ref = React.useRef<string>();

  React.useEffect(() => {
    if (!account || !account.id) {
      return;
    }

    ref.current = account.id;
  }, [account]);

  if (!ref.current) {
    return false;
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  if (ref.current !== account.id) {
    return true;
  }

  return false;
}

export default useHasAccountChanged;
